import { useEffect } from "react";

// ID の設定画面とは別タブ・別オリジンでも、戻ったときに最新の設定を取得する。
export const useRefreshWorkspaceAppearance = (
  refresh: () => Promise<void>,
  enabled: boolean,
) => {
  useEffect(() => {
    if (!enabled) return;
    let refreshing = false;
    const onResume = () => {
      if (document.visibilityState !== "visible" || refreshing) return;
      refreshing = true;
      void Promise.resolve()
        .then(refresh)
        // バックグラウンド取得の失敗で、現在の画面や編集中の入力を失わない。
        .catch(() => {})
        .finally(() => {
          refreshing = false;
        });
    };
    window.addEventListener("focus", onResume);
    document.addEventListener("visibilitychange", onResume);
    return () => {
      window.removeEventListener("focus", onResume);
      document.removeEventListener("visibilitychange", onResume);
    };
  }, [refresh, enabled]);
};
